/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { createAction, createSlice, createSelector } from '@reduxjs/toolkit';

import createRequestActionTypes from 'store/helpers/createRequestActionTypes';
import {
  handleClearErrors,
  onFailure,
  onSuccessList,
} from 'store/helpers/commonHandlers';

const name = 'payments';

/** ActionType for Request */
export const [
  GET_NOT_PAID_PAYMENT_LIST,
  GET_NOT_PAID_PAYMENT_LIST_SUCCESS,
  GET_NOT_PAID_PAYMENT_LIST_FAILURE,
] = createRequestActionTypes(name, 'GET_NOT_PAID_PAYMENT_LIST');
export const [
  GET_PAYMENT_LIST,
  GET_PAYMENT_LIST_SUCCESS,
  GET_PAYMENT_LIST_FAILURE,
] = createRequestActionTypes(name, 'GET_PAYMENT_LIST');
export const [
  PREPARE_PAYMENT,
  PREPARE_PAYMENT_SUCCESS,
  PREPARE_PAYMENT_FAILURE,
] = createRequestActionTypes(name, 'PREPARE_PAYMENT');
export const [
  NOTIFY_PAYMENT,
  NOTIFY_PAYMENT_SUCCESS,
  NOTIFY_PAYMENT_FAILURE,
] = createRequestActionTypes(name, 'NOTIFY_PAYMENT');

const slice = createSlice({
  name,
  initialState: {
    list: null,
    notPaidList: null,
    errors: {},
    count: {},
    next: {},
  },
  reducers: {
    clearErrors: handleClearErrors,
  },
  extraReducers: {
    [PREPARE_PAYMENT_FAILURE]: onFailure('preparePayment'),
    [GET_NOT_PAID_PAYMENT_LIST_SUCCESS]: onSuccessList('notPaidList'),
    [GET_NOT_PAID_PAYMENT_LIST_FAILURE]: onFailure('notPaidList'),
    [GET_PAYMENT_LIST_SUCCESS]: onSuccessList('list'),
    [GET_PAYMENT_LIST_FAILURE]: onFailure('list'),
    [NOTIFY_PAYMENT_FAILURE]: onFailure('notify'),
  },
});

/** Action for Request */
export const preparePayment = createAction(PREPARE_PAYMENT);
export const getNotPaidPaymentList = createAction(GET_NOT_PAID_PAYMENT_LIST);
export const getPaymentList = createAction(GET_PAYMENT_LIST);
export const notifyPayment = createAction(NOTIFY_PAYMENT);

/** General Action */
export const { clearErrors } = slice.actions;

/** Reducer */
export const payments = slice.reducer;

/** Selectors */
const errorSelector = createSelector(
  (state) => state.errors,
  (errors) => ({ errors }),
);
const notPaidSelector = createSelector(
  (state) => state.notPaidList,
  (state) => state.count.notPaidList,
  (notPaidList, notPaidCount) => ({ notPaidList, notPaidCount }),
);
const listSelector = createSelector(
  (state) => state.list,
  (state) => state.count.list,
  (allPayment, allCount) => ({ allPayment, allCount }),
);
export const selectors = {
  errors: (state) => errorSelector(state[name]),
  notPaidList: (state) => notPaidSelector(state[name]),
  list: (state) => listSelector(state[name]),
};

export default slice;
